import _JSON$stringify from 'babel-runtime/core-js/json/stringify';

import _ from 'lodash';
import { getVideoStatus } from '@/api/automation/automation';
import { automationPlatformHost } from '@/config/host';
import videoUploader from './uploader.vue';
import { mtgVideoSizes, dspVideoSizes, videoOutputTypes, uncategorizedVideoSizes, fbVideoSizes } from '@/views/automation/utils';

var videoSizes = dspVideoSizes.concat(mtgVideoSizes, uncategorizedVideoSizes, fbVideoSizes);

export default {
  data: function data() {
    return {
      form: {
        id: 0,
        video: null,
        videoSizes: [],
        outputVideoType: [],
        platform: '0'
      },

      rules: {
        video: [{ required: true, message: '请上传视频', trigger: 'change' }],
        videoSizes: [{ required: true, message: '请选择尺寸', trigger: 'change' }],
        outputVideoType: [{ required: true, message: '请选择输出格式', trigger: 'change' }]
      },

      progress: {
        percentage: 0,
        strokeWidth: 18,
        textInside: true,
        sizeDone: 0,
        sizeCount: 0
      },

      platformSelector: {
        list: []
      },

      videoSizeSelector: {
        list: videoSizes
      },

      videoOutputTypesSelector: {
        list: videoOutputTypes()
      },

      downloadUrl: '',
      uploading: false
    };
  },

  components: {
    videoUploader: videoUploader
  },

  computed: {
    submitButtonDisabled: function submitButtonDisabled() {
      if (this.form.video && this.form.videoSizes && this.form.videoSizes.length > 0 && !this.form.id && this.form.outputVideoType && this.form.outputVideoType.length > 0) {
        return false;
      }
      return true;
    },
    uploader: function uploader() {
      return {
        uploadData: {
          size_args: _JSON$stringify(this.form.videoSizes),
          ext_args: _JSON$stringify(this.form.outputVideoType),
          size_type: this.form.platform
        },
        uploadUrl: automationPlatformHost + '/upload'
      };
    }
  },

  methods: {
    submit: function submit() {
      var _this = this;

      this.$refs['form'].validate(function (valid) {
        if (valid) {
          _this.progress.sizeDone = 0;
          _this.progress.sizeCount = _this.form.videoSizes.length;
          _this.$nextTick(function () {
            _this.$refs.uploader.submit();
          });
          _this.fakeProcess();
          _this.uploading = true;
        }
      });
    },
    uploadSuccess: function uploadSuccess(id) {
      this.form.id = id;
      this.downloadUrl = '';
      this.checkProcess();
    },
    handleTypeChange: function handleTypeChange(val) {
      var type = Number(val);
      this.form.id = '';
      switch (type) {
        case 1:
          this.form.videoSizes = videoSizes;
          break;
        case 2:
          this.form.videoSizes = dspVideoSizes;
          break;
        case 3:
          this.form.videoSizes = mtgVideoSizes;
          break;
        case 4:
          this.form.videoSizes = fbVideoSizes;
          break;
        default:
          break;
      }
    },
    uploadComplete: function uploadComplete(downloadUrl) {
      var _this2 = this;

      this.$message({ message: '处理完成', type: 'success' });
      this.progress.percentage = 100;
      setTimeout(function () {
        _this2.downloadUrl = downloadUrl;
        _this2.uploading = false;
      }, 500);
    },
    updateUploadProgress: function updateUploadProgress(sizeDone) {
      this.progress.sizeDone = sizeDone;
      var realProcess = Math.ceil(this.progress.sizeDone / this.progress.sizeCount * 100);
      if (realProcess > this.progress.percentage && realProcess !== 100) {
        this.progress.percentage = realProcess;
      }
    },
    resetProgress: function resetProgress() {
      this.uploading = false;
    },
    checkProcess: function checkProcess() {
      var _this3 = this;

      getVideoStatus({
        id: this.form.id
      }).then(function (res) {
        var data = _.get(res, 'data.data') || {};

        if (data.status !== 4) {
          if (data.status === 2) {
            _this3.updateUploadProgress(data.size_done);
          }
          setTimeout(function () {
            return _this3.checkProcess();
          }, 1000);
        } else {
          _this3.uploadComplete(data.download_url);
        }
      });
    },
    handleCheckedSizesChange: function handleCheckedSizesChange(value) {
      this.form.id = '';
      console.log('handleCheckedSizesChange', value);
    },
    setVideo: function setVideo(value) {
      this.form.id = '';
      this.form.video = value;
    },
    fakeProcess: function fakeProcess() {
      var _this4 = this;

      this.progress.percentage = 0;
      var changeProcess = function changeProcess() {
        var time = [20, 100, 160, 240, 320, 400];
        setTimeout(function () {
          if (_this4.progress.percentage < 95) {
            _this4.progress.percentage = _this4.progress.percentage + 1;
            changeProcess();
          }
        }, time[Math.floor(Math.random() * 6)] * 5);
      };
      changeProcess();
    }
  }
};